import styled from "styled-components";

export const StickyWrap = styled.div<{ $elevated: boolean; $hasFilters?: boolean }>`
  position: sticky;
  top: 0;
  z-index: 20;
  background: #fff;
  padding: 8px 16px;
  padding-top: max(8px, env(safe-area-inset-top));
  padding-bottom: ${(p) => (p.$hasFilters ? "12px" : "8px")};
  box-shadow: ${(p) =>
    p.$elevated || p.$hasFilters ? "0 1px 4px rgba(0,0,0,0.2)" : "none"};
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const CollapsedRow = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  text-align: left;
  background: #f6f6f6;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  padding: 8px 8px 8px 4px;
  cursor: pointer;
`;

export const IconBtn = styled.button`
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  flex-shrink: 0;
`;

export const InfoBlock = styled.div`
  flex: 1;
  min-width: 0;
  padding: 0 8px;
`;

export const CountryLine = styled.div`
  font-size: 12px;
  font-weight: 900;
  color: #000;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DetailLine = styled.div`
  font-size: 12px;
  color: #757575;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
`;

export const Emphasis = styled.span`
  color: #000;
  font-weight: 700;
  font-size: 12px;
`;

export const EditCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  flex-shrink: 0;
  width: 22px;
`;

export const EditLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #008cff;
`;

/** Above sticky header (20); below listing sheets (400+) and compare modal (500). */
export const LISTING_CONTEXT_EDIT_MODAL_Z = 100;

/** Pass as `zIndex` on CountrySelector / DateRangeSelector so portaled pickers stack above the edit modal. */
export const LISTING_CONTEXT_PICKER_Z_INDEX = 110;

export const ModalRoot = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${LISTING_CONTEXT_EDIT_MODAL_Z};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const ModalBackdrop = styled.button`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  cursor: pointer;
`;

export const ModalPanel = styled.div`
  position: relative;
  background: #fff;
  max-height: 100%;
  overflow-y: auto;
  border-radius: 0 0 16px 16px;
  padding: 16px;
  padding-top: max(16px, env(safe-area-inset-top));
  animation: lp-slide 0.28s ease-out;

  @keyframes lp-slide {
    from {
      transform: translateY(-24px);
      opacity: 0.6;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 16px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #000;
`;

export const FieldBlock = styled.div`
  margin-bottom: 8px;
`;

export const ErrorText = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  color: #c62828;
`;

export const CountryScroll = styled.div`
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #d8d8d8;
  border-radius: 0 0 8px 8px;
  border-top: none;
  margin-top: -1px;
`;

export const CountrySection = styled.div`
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 700;
  color: #757575;
  background: #f6f6f6;
  border-bottom: 1px solid #d8d8d8;
`;

export const CountryRow = styled.button<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  background: ${(p) => (p.$selected ? "#eaf5ff" : "#fff")};
  cursor: pointer;
  font-size: 14px;
  color: #000;

  &:last-child {
    border-bottom: none;
  }
`;
